import { addDays, format, parseISO } from "date-fns";
import React, { useEffect } from "react";
import { useCallback } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Loading from "react-loading";
import LoadingEffect from "../../components/LoadingEffect";
import ToggleSwitch from "../../components/ToggleSwitch";
import { Button } from "../../styles-components/Buttons";
import { Container } from "../../styles-components/Container";
import {
  Column,
  ErrorMessage,
  Form,
  FormHeader,
  Label,
  Row,
  RowOption,
} from "../../styles-components/FormItens";
import inputFormat from "../../utils/inputFormat";
import UseRedirectView from "../../utils/UseRedirectView";
import { RowSearching } from "./styles";
import { apiClientPrice, apiGroupEnterprise } from "../../services/data/index";
import { toast } from "react-toastify";
const FormServicesValue = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(true);
  const [clients, setClients] = useState([]);
  const [services ,setServices] = useState([]);

  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
    unregister,
    getValues
  } = useForm();

  const [watchHasValidity, watchService, watchClient, watchStart] = watch([
    "has_validity",
    "service_id",
    "group_enterprises_id",
    "date_start"
  ]);


  useEffect(() => {
    fetchData();
  }, [])

  useEffect(() => {
    if (watchHasValidity !== "" && watchHasValidity !== undefined) {
      if (!watchHasValidity) {
        unregister("date_end");
      }
    }
  }, [watchHasValidity]);

  const onSubmit = useCallback(async (data) => {
    try {
      await apiClientPrice.store(data).then(response => {
        if(response.data.data && response.data.data.error) {
          toast.error(response.data.data.message,  { toastId: response.data.data.type });
        } else {
          toast.success("Preço cadastrado com sucesso!");
          UseRedirectView.to("servicos/valores/listagem");
        }
      })
    } catch (error) {
      toast.error("Algo deu errado!");
    }
  }, []);

  const fetchService = useCallback(async (id) => {
    setIsSearching(true);
    await apiClientPrice.search(id).then(response => {
      response.data.data.sort(function (a, b) {
        return a.service.nome > b.service.nome ? 1 : b.service.nome > a.service.nome ? -1 : 0;
      });
      setServices(response.data.data);
      setIsSearching(false);
    })
  }, [setIsSearching, setServices, apiClientPrice]);

  const fetchData = useCallback(async () => {
    await apiGroupEnterprise.index().then(response => {
      setClients(response.data.data);
      setIsLoading(false);
    })
  }, [setClients, apiGroupEnterprise]);

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <Container>
          <FormHeader>
            <h1>Cadastrar preço</h1>
            <Button color={"--white"} backgroundColor={"--orange"} onClick={() => UseRedirectView.to('servicos/valores/listagem')}>
              Voltar
            </Button>
          </FormHeader>
          <Form method="POST" onSubmit={handleSubmit(onSubmit)}>
            <Column>
              <Row>
                <Label>Cliente:</Label>
                <select
                  {...register("group_enterprises_id", {
                    required: { value: true, message: "Informe um cliente!" },
                    onChange: v => fetchService(v.target.value)
                  })}
                  style={errors.group_enterprises_id && { ...inputFormat }}
                >
                  <option></option>
                  {clients.map(cliente => (
                    <option key={cliente.id} value={cliente.id}>{cliente.name}</option>
                  ))}
                </select>
              </Row>
              {errors.group_enterprises_id && (
                <ErrorMessage color={"--red"}>
                  {errors.group_enterprises_id.message}
                </ErrorMessage>
              )}
            </Column>
            {watchClient !== "" && watchClient !== undefined && (
              <>
                <Column>
                  <Row>
                    {isSearching ? (
                      <RowSearching>
                        {
                          <Loading
                            type={"spinningBubbles"}
                            color={"#086BAB"}
                            height={"30px"}
                            width={"30px"}
                          />
                        }
                        <span>Buscando serviços do cliente</span>
                      </RowSearching>
                    ) : (
                      <>
                        <Label>Serviço:</Label>
                        <select
                          {...register("service_id", {
                            required: {
                              value: true,
                              message: "Informe um serviço!",
                            },
                          })}
                          style={errors.service_id && { ...inputFormat }}
                        >
                          <option></option>
                          {services.map(service => (
                            <option key={service.service.id} value={service.service.id}>{service.service.nome}</option>
                          ))}
                        </select>
                      </>
                    )}
                  </Row>
                  {errors.service_id && (
                    <ErrorMessage color={"--red"}>
                      {errors.service_id.message}
                    </ErrorMessage>
                  )}
                </Column>
                {watchService && (
                  <>
                    <RowOption>
                      <ToggleSwitch register={register} name={"has_validity"} />
                      <Label>Este valor já possui validade?</Label>
                    </RowOption>
                    <Column>
                      <Row>
                        <Label htmlFor="date_start">Início de aplicação:</Label>
                        <input
                          type="date"
                          {...register("date_start", {
                            required: {
                              value: true,
                              message: `Informe uma data ${
                                watchHasValidity ? "de início" : ""
                              }!`,
                            },
                          })}
                          style={errors.date_start && { ...inputFormat }}
                          id="date_start"
                        />
                      </Row>
                      {errors.date_start && (
                        <ErrorMessage color={"--red"}>
                          {errors.date_start.message}
                        </ErrorMessage>
                      )}
                    </Column>
                    {watchHasValidity && (
                      <>
                        <Column>
                          <Row>
                            <Label htmlFor="date_end">Fim de aplicação:</Label>
                            <input
                              type="date"
                              min={watchStart && format(addDays(parseISO(getValues('date_start')), +1), 'yyyy-MM-dd')}
                              {...register("date_end", {
                                required: {
                                  value: true,
                                  message: "Informe uma data final!",
                                },
                              })}
                              style={errors.date_end && { ...inputFormat }}
                              id="date_end"
                            />
                            {errors.date_end && (
                              <ErrorMessage color={"--red"}>
                                {errors.date_end.message}
                              </ErrorMessage>
                            )}
                          </Row>
                        </Column>
                      </>
                    )}
                    <Column>
                      <Row>
                        <Label htmlFor="value">Preço:</Label>
                        <input
                          type="float"
                          {...register("value", {
                            required: {
                              value: true,
                              message: "Informe um valor!",
                            },
                            min: {
                              value: 1,
                              message: "Informe um valor maior que 0!",
                            },
                          })}
                          style={errors.value && { ...inputFormat }}
                          id="value"
                        />
                      </Row>
                      {errors.value ? (
                        <ErrorMessage color={"--red"}>
                          {errors.value.message}
                        </ErrorMessage>
                      ) : (
                        <ErrorMessage color={"--yellow"}>
                          Use o ponto para determinar números não inteiros (Ex:
                          9.99)
                        </ErrorMessage>
                      )}
                    </Column>
                    {watchService && (
                      <Button
                        color="--white"
                        backgroundColor="--orange"
                        align="flex-end"
                      >
                        Criar
                      </Button>
                    )}
                  </>
                )}
              </>
            )}
          </Form>
        </Container>
      )}
    </>
  );
};

export default FormServicesValue;
